import { takeLatest } from 'redux-saga/effects';

import {
  GENERATE_INVOICE
} from '../actions';

import { createInvoice } from './sagas';

// Watchers
export function* onRequestGenerateInvoice() {
  yield takeLatest(GENERATE_INVOICE, createInvoice);
}



// WEBPACK FOOTER //
// ./src/modules/invoice/actions/watchers.js